import { trim as _trim, size as _size } from 'lodash';

export default (stringValue: string): boolean => {
    return stringValue === '' || _size(_trim(stringValue)) === 0;
};
